module.exports = __webpack_public_path__ + "static/media/iconHome.aa54ac8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconHome.svg
// module id = 1009
// module chunks = 0